import {
	PropsWithChildren,
	ReactElement,
	useEffect
} from "react";
import { SettingsSidebar } from "./SidebarMenu/SettingsSidebar";
import { GlobalNavigationCriteria, useGlobalNavigationStore } from "../Layout/TitleBar/GlobalNavigation/globalNavigationStore";
import { usePageTitle } from "client/Hooks/usePageTitle";
import { localize } from "client_legacy/ndaw/culture";

export const SettingsLayout = (props: PropsWithChildren<{}>): ReactElement => {
	const {
		children
	} = props;

	const setActiveCriteria: (criteria: GlobalNavigationCriteria) => () => void = useGlobalNavigationStore(x => x.setActiveCriteria);

	useEffect(
		(): EffectWithDestructorResult => {
			return setActiveCriteria({
				type: "settings"
			});
		},
		[setActiveCriteria]
	);

	usePageTitle(localize("_Settings"));

	return (
		<>
			<SettingsSidebar />
			<div id="main-content">
				{children}
			</div>
		</>
	);
};
SettingsLayout.displayName = "SettingsLayout";